module.exports = __webpack_public_path__ + "img/in-partnership-with-ja.a395f0ff.svg";